/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";

import { Card, Col, Row, Table, Button, Select } from "antd";
import EventsMap from "../charts/EventsMap";

import { util } from "../../utils/functions/custom";
import { recordError } from "src/utils/logService";

import "antd/dist/reset.css";

import eventsAPI from "../../services/eventsAnalyticsService";
import { ReportTemplate } from "../custom/ReportTemplate";

import { CSVLink } from 'react-csv'
import commonLookupService from "../../services/commonLookupService";

export const EventsGeographicReport = (props) => {
  const { filterType } = props;

  const [provincialDistributionData, setProvincialDistributionData] = useState([]);

  const [eventDetails, setEventDetails] = useState({});
  const [showEventDetails, setshowEventDetails] = useState(false);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [filterId, setFilterId] = useState();
  const [show, setShow] = useState(false);
  const [isGeo, setIsGeo] = useState(false);

  const [eventList, setEventList] = useState([])
  const [csvData, setCsvData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [firstRecord, setFirstRecord] = useState(0);

  const [filterProvince, setFilterProvince] = useState(-1);
  const [filterDistrict, setFilterDistrict] = useState(-1);

  const [provinces, setProvinces] = useState([]);
  const [saProvinces, setSAProvinces] = useState([]);
  const [districts, setDistricts] = useState([{ key: -1, value: "All Districts" }]);
  const [provinceData, setProvinceData] = useState([]);
  const [provinceId, setProvinceId] = useState(-1);
  const [districtId, setDistrictId] = useState(-1);

    const [initialised, setInitialised] = useState(false);

    const [reportYear, setReportYear] = useState(util.getCurrentRepotYear());
    const [financialYears, setFinancialYears] = useState(util.getCurrentFinancialYear());

  const [reportOutProps, setReportOutProps] = useState({
    data: [],
    color: "",
    type: "",
    year: 0,
    description: "",
    xLabel: "",
    yLabel: "",
  });

  const { Option } = Select;
  const eventsProvincialDistribution = "Distribution of Events by Province";

  let latestTableRequestId = 0;
  let latestMapRequestId = 0;

  useEffect(() => {

    if (!initialised) {
      setFinancialYears(util.getCurrentFinancialYear());
      util.getYearsWithReports(eventsAPI, setFinancialYears, setReportYear, true);
      setInitialised(true);
    }
    setStartDate(reportYear);
    setEndDate(reportYear);
    // getYearRange();
    initiateReportData(reportYear);
    generateData(reportYear, -1, -1);
    getProvinceData()
    getSAProvinces()
    getDistrict();
    getProvinceMapData(reportYear);
  }, [filterType, reportYear]);

  const generateData = async (year, provId, distId) => {
    const requestId = ++latestTableRequestId;

    try {
      const response = await eventsAPI.getEventLocationsList(year, provId, distId);

      // Ignore stale responses
      if (requestId !== latestTableRequestId) return;

      if (response && response.status === 200) {
        const results = response.data?.results || [];

        setEventList(results);
        setTotal(results.length);

        const csvData1 = results.map((element) => ({
          Name: element.eventName,
          "Event Type": element.eventType,
          "Event Description": element.eventDescription,
          "Event Date": element.eventDate,
          "Venue Name": element.venueName,
          "Venue Address": element.venueAddress,
          "Venue District": element.venueDistrict,
          "Venue Province": element.venueProvince,
          "Host Organisation Name": element.hostOrganisationName,
          "Event Organiser": element.eventOrganiser,
          "Event Organiser Email": element.eventOrganiserEmail,
        }));

        setCsvData(csvData1);
        setCurrentPage(1);
        setFirstRecord(0);
      } else {
        setEventList([]);
        setTotal(0);
        setCsvData([]);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getProvinceData = async () => {
    try {
      const response = await eventsAPI.getProvinces();
      if (response && response.status === 200) {
        const { data } = response;
        setProvinces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getSAProvinces = async () => {
    try {
      const response = await commonLookupService.getProvincesDistrict();

      if (response && response.status === 200) {
        const { data } = response;

        const allProvince = { key: -1, value: "All Provinces" };
        const updated = [allProvince, ...data];

        setSAProvinces(updated);

        // set AFTER options exist
        setFilterProvince(-1);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getDistrict = async () => {
    try {
      const response = await commonLookupService.getProvincesDistrictTowns();
      if (response && response.status === 200) {
        setFilterDistrict({});
        setDistricts([]);
        const { data } = response;
        const allDistricts = { key: -1, value: "All Districts" };
        data.unshift(allDistricts);
        setFilterDistrict(-1)
        setDistricts(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const columns = [
    {
      title: "Event Name",
      dataIndex: "eventName",
      key: "eventName",
      sorter: (a, b) => a.eventName.localeCompare(b.eventName),
    },
    {
      title: "Event Type",
      dataIndex: "eventType",
      key: "eventType",
      sorter: (a, b) => a.eventType.localeCompare(b.eventType),
    },
    {
      title: "Event Description",
      dataIndex: "eventDescription",
      key: "eventDescription",
    },
    {
      title: "Event Date",
      dataIndex: "eventDate",
      key: "eventDate",
      sorter: (a, b) => a.eventDate.localeCompare(b.eventDate),
    },
    {
      title: "Venue Name",
      dataIndex: "venueName",
      key: "venueName",
      sorter: (a, b) => a.venue.localeCompare(b.venue),
    },
    {
      title: "Venue Address",
      dataIndex: "venueAddress",
      key: "venueAddress",
    },
    {
      title: "Venue District",
      dataIndex: "venueDistrict",
      key: "venueDistrict",
      sorter: (a, b) => a.venueDistrict.localeCompare(b.venueDistrict),
    },
    {
      title: "Venue Province",
      dataIndex: "venueProvince",
      key: "venueProvince",
      sorter: (a, b) => a.venueProvince.localeCompare(b.venueProvince),
    },
    {
      title: "Host Organisation Name",
      dataIndex: "hostOrganisationName",
      key: "hostOrganisationName",
    },
    {
      title: "Event Organiser",
      dataIndex: "eventOrganiser",
      key: "eventOrganiser",
    },
    {
      title: "Event Organiser Email",
      dataIndex: "eventOrganiserEmail",
      key: "eventOrganiserEmail",
    },
  ];

  const onYearChange = (value) => {
    setReportYear(value);

    // Reset UI immediately
    setEventList([]);
    setTotal(0);
    setFirstRecord(0);
    setCurrentPage(1);

    // Always pass value (NOT state)
    getProvinceMapData(value);
    getEventsData(value);
    generateData(value, -1, -1);
  };

  const getProvinceMapData = async (year) => {
    const requestId = ++latestMapRequestId;

    try {
      const response = await eventsAPI.getProvinceEvents(year);

      // Ignore stale responses
      if (requestId !== latestMapRequestId) return;

      if (response && response.status === 200) {
        setProvinceData(response.data);
      } else {
        setProvinceData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onPageChange = (page, size) => {
    const keepCurrentPage = pageSize === size;
    const first = keepCurrentPage ? (page - 1) * pageSize : 0;
    const newPage = keepCurrentPage ? page : 1;
    setFirstRecord(first);
    setPageSize(size);
    setCurrentPage(newPage);
  }

  const getEventsData = async (repYear) => {
    try {
      const response = await eventsAPI.getEvents(repYear, true);
      if (response && response.status === 200) {
        const { data } = response;
        setEventList(data.results);
    
        const selectedEvent = data[0];
        setFilterId(selectedEvent.id);
        setEventDetails(selectedEvent);
        updateAnalytics(repYear, selectedEvent.id);
      } else {
        setEventList([]);
        setFilterId();
      }
    } catch (error) { }
  };

  const clearFilters = (e) => {
    e.preventDefault();

    const allDistricts = { key: -1, value: "All Districts" };

    setFilterProvince(-1);
    setFilterDistrict(-1);

    setProvinceId(-1);
    setDistrictId(-1);

    // Reset districts properly (not empty)
    setDistricts([allDistricts]);

    setFirstRecord(0);
    setCurrentPage(1);

    generateData(reportYear, -1, -1);
  };

  const initiateReportData = (repYear) => {
    getEventsData(repYear);
  }

  const getProvincialDistributionData = async (year, filterId) => {
    try {
      const response = await eventsAPI.getProvincialDistribution(year, filterId, filterType);
      if (response && response.status === 200) {
        const { data } = response;
        setProvincialDistributionData(data);
      } else {
        setProvincialDistributionData([]);
      }
    } catch (error) { }
  };

  const updateAnalytics = (repYear, filterId) => {
    getProvincialDistributionData(repYear, filterId);
  };

  const handlePrintCancel = () => {
    setShow(false);
    setIsGeo(false);
    const rptProps = { ...reportOutProps };
    rptProps.title = "";
    rptProps.description = "";
    rptProps.color = undefined;
    rptProps.data = [];
    rptProps.type = undefined;
    rptProps.year = 0;
    rptProps.dataSource = "";
    setReportOutProps(rptProps);
  };

  const onProvinceChange = (key) => {
    setProvinceId(key);
    setDistrictId(-1);

    setFilterProvince(key);
    setFilterDistrict(-1);

    setFirstRecord(0);
    setCurrentPage(1);

    const selectedProvince = saProvinces.find((prov) => prov.key === key);

    if (selectedProvince && selectedProvince.districts) {
      let dist = [...selectedProvince.districts];

      // Ensure "All Districts" exists
      if (!dist.some((d) => d.key === -1)) {
        dist.unshift({ key: -1, value: "All Districts" });
      }

      setDistricts(dist);
    } else {
      setDistricts([{ key: -1, value: "All Districts" }]);
    }

    generateData(reportYear, key, -1);
  };

  const onDistrictChange = (key) => {
    setDistrictId(key);
    setFilterDistrict(key);

    setFirstRecord(0);
    setCurrentPage(1);

    generateData(reportYear, provinceId, key);
  };

  const data = [
    {
      key: '1',
      name: 'Event date',
      age: eventDetails.dates,
    },
    {
      key: '2',
      name: 'Event group',
      age: eventDetails.group,
    },
    {
      key: '3',
      name: 'Event type',
      age: eventDetails.type,
    },
    {
      key: '4',
      name: 'Event venue',
      age: eventDetails.venue,
    },
    {
      key: '5',
      name: 'Host organisation',
      age: eventDetails.hostOrganisation,
    },
    {
      key: '6',
      name: 'Event description ',
      age: eventDetails.description,
    },
    {
      key: '7',
      name: 'Total number of participants ',
      age: eventDetails.totalParticipants,
    },
  ];

  return (
    <>
      <div className="report-nys-content">
        <h2 className="report-heading">National Science Month</h2>
        <div className="reportYear">
          <Row
            style={{
              borderRadius: "10px",
            }}
          >
            <Col
              xs={11}
              md={11}
              style={{
                borderRadius: "10px",
              }}
            >
              <div className="reportYearContainer">
                <div
                  style={{
                    margin: "0px auto",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Financial year : &nbsp;
                   <Select
                    // style={{ width: "65%" }}
                    placeholder="Please select financial year"
                    onChange={onYearChange}
                    loading={!financialYears.length}
                    value={reportYear}
                    size="large"
                  >
                    {financialYears?.map((year) => {
                      return (
                        <Option key={year.id} value={year.id}>
                          {year.value}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              </div>
            </Col>
            </Row>
            </div>
        <Row style={{ display: showEventDetails ? 'block' : 'none' }}>
          <Col xs={24} md={14} lg={14} offset={5}>
            <Table columns={columns} dataSource={data} pagination={false} size="small" />
          </Col>
        </Row>
      </div>
      <div className="space"></div>
      <Row span={25} style={{ paddingBottom: 40 }} gutter={16}>
        <Col xs={24} md={24}>
          <Card
            bordered={true}
          >
            <EventsMap
              data={provinceData}
              provinces={provinces}
              reportingYear={reportYear}
              hoverText={eventsProvincialDistribution}
              dataSource={"Events"}
            />
            <br></br>
            <div className='content'>
              <Col xs={24}>
                <h2 className="report-heading">Events List</h2>
              </Col>
              <div className='report-nys-content'>

                <br />
                <div justify="left">
                  <Row>
                    <Col style={{ marginLeft: "10px" }}><span>Filter By  &nbsp;</span></Col>
                    <Col>
                      <Select
                        style={{ width: 200, marginLeft: "10px" }}
                        onChange={onProvinceChange}
                        value={filterProvince}
                        loading={!saProvinces.length}
                      >
                        {saProvinces.map(option => (
                          <Option key={option.key} value={option.key}>
                            {option.value}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col>
                      <Select
                        style={{ width: 200, marginLeft: "10px" }}
                        onChange={onDistrictChange}
                        value={filterDistrict}
                        loading={!districts.length}
                      >
                        {districts.map(option => (
                          <Option key={option.key} value={option.key}>
                            {option.value}
                          </Option>
                        ))}
                      </Select>
                    </Col>
                    <Col>
                      <a
                        style={{ marginLeft: "10px", color: "#54AAEE", fontWeight: "bold" }}
                        href="#"
                        onClick={(e) => {
                          clearFilters(e);
                        }}
                      >
                        Clear applied filters
                      </a>
                    </Col>
                  </Row>
                </div>
                <br />
                <CSVLink
                  filename={"TableContent.csv"}
                  data={csvData}
                  className="btn btn-primary"
                >
                  <Button
                    style={{ borderRadius: "10px", marginLeft: "10px" }}
                    key="export"
                    type="primary"
                  >
                    Export to csv
                  </Button>
                </CSVLink>

                <Table
                  dataSource={eventList}
                  rowKey={(record) => record.key}
                  columns={columns}
                  bordered
                  pagination={{
                    defaultCurrent: 1,
                    current: currentPage,
                    defaultPageSize: pageSize,
                    total: total,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: onPageChange,
                    pageSizeOptions: [2, 5, 10, 20, 50, 100],
                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} ${total > 1 ? 'Events' : 'Event'}`,
                  }}
                  size="middle"
                  key="2"
                />
              </div>
            </div>

          </Card>
        </Col>
      </Row>
      <ReportTemplate
        onCancel={handlePrintCancel}
        reportOutProps={reportOutProps}
        show={show}
        key="reportTemplateEvents"
        isGeo={isGeo}
      />
    </>
  );
};

